interface StepIconProps {
	icon: number;
	active: boolean;
	visited: boolean;
	clickable: boolean;
	onClick: () => void;
}

const StepIcon: React.FC<StepIconProps> = ({ icon, active, visited, onClick, clickable }) => {
	return (
		<div
			className={active ? 'active-step-number' : visited ? 'visited-step-number' : 'disabled-step-number'}
			onClick={onClick}
			style={{ cursor: clickable ? 'grab' : 'cursor' }}
		>
			{icon}
		</div>
	);
}

export default StepIcon;